/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from "react";
import { AppRoot, PageContainer } from "./src/PageContainer";
import GlobalErrorBoundary from "./src/Components/GlobalErrorBoundary";
import "./src/polyfill";

export const wrapPageElement = ({ element, props }) => {
  return <PageContainer {...props}>{element}</PageContainer>;
};

export const wrapRootElement = ({ element }) => {
  return (
    <GlobalErrorBoundary>
      <AppRoot>{element}</AppRoot>
    </GlobalErrorBoundary>
  );
};

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
    window.__GATSBY_INITIAL_PROPS = window.__GATSBY_INITIAL_PROPS || {};
  }

  if (process.env.NODE_ENV === "production") {
    // 更精確的錯誤處理
    window.addEventListener("error", (event) => {
      // 只處理真正的資源載入錯誤，排除 JavaScript 執行錯誤
      if (
        event.target !== window &&
        event.target.tagName &&
        (event.target.tagName === "SCRIPT" ||
          event.target.tagName === "LINK" ||
          event.target.tagName === "IMG")
      ) {
        console.error("Critical resource loading error:", event);
        if (window.location.pathname !== "/404") {
          window.location.replace("/404");
        }
      } else {
        // 記錄 JavaScript 錯誤但不重定向
        console.error("JavaScript error (not redirecting):", event.error);
      }
    });

    window.addEventListener("unhandledrejection", (event) => {
      console.error("Unhandled promise rejection:", event.reason);

      // 只有在特定的嚴重錯誤時才重定向到 404
      // 例如：網路錯誤、認證錯誤等
      if (
        event.reason &&
        (event.reason.message?.includes("Network Error") ||
          event.reason.message?.includes("Failed to fetch") ||
          event.reason.status === 404)
      ) {
        console.error("Critical promise rejection, redirecting to 404");
        if (window.location.pathname !== "/404") {
          window.location.replace("/404");
        }
      } else {
        // 防止瀏覽器顯示未處理的 promise rejection 警告
        event.preventDefault();
      }
    });
  }
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (process.env.NODE_ENV !== "production") {
    console.log("路由更新:", location.pathname);
    console.log("前一個路由:", prevLocation ? prevLocation.pathname : null);
  }
};

export const shouldUpdateScroll = ({ routerProps }) => {
  if (routerProps?.location?.state?.noScroll) {
    return false;
  }
  return true;
};
